var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QualificationRoomType } from '@shared/types/api/claim';
const settings = namespace('settings');
let HouseCrossSection = class HouseCrossSection extends Vue {
    constructor() {
        super(...arguments);
        this.RoomType = QualificationRoomType;
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    get customConfig() {
        var _a, _b, _c, _d, _e, _f, _g;
        return (((_g = (_f = (_e = (_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.roomDamagesContents) === null || _d === void 0 ? void 0 : _d.housingConfigurationByHousingType) === null || _e === void 0 ? void 0 : _e.house) === null || _f === void 0 ? void 0 : _f.selectedRoomsMapping) === null || _g === void 0 ? void 0 : _g.insideHouse) || null);
    }
    leakageLocation(location) {
        var _a;
        return ((_a = this.customConfig) === null || _a === void 0 ? void 0 : _a[location]) || location;
    }
};
__decorate([
    settings.Getter('setting')
], HouseCrossSection.prototype, "setting", void 0);
HouseCrossSection = __decorate([
    Component({
        props: {
            selectedRoom: {
                type: String,
                default: null,
            },
            hoveredRoom: {
                type: String,
                default: null,
            },
        },
    })
], HouseCrossSection);
export default HouseCrossSection;
